module.exports = __webpack_public_path__ + "static/media/06_tn.1719767e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/06_tn.jpg
// module id = 642
// module chunks = 0